import axios from 'axios'
// import router from '@/router'
import qs from 'qs'
import { clone, objectSnakeToCamelCase, getDefaultStrDate, blobPDF } from '@/util/libUtil.js'
import router from '../../router'
import html2canvas from 'html2canvas';


// Estado inicial
const state = () => ({
    StatusSnackBar: {
        statusType: 'success',
        message: '',
        isVisible: false,
    },
    deleteDialog: {
        toDeleteId: '',
        additionalParams: {},
        toDeleteType: '',
        isOpenDeleteDialog: false
    },
    isOpenLegendDialog: false,
    opciones: null,
    isMaintaining: false,
    tenantInfo: {},
    origenesBbdd: null,
    tipoObjetivo: [],
    navBarSearchField: '',
    exportingProgress: 0,
    isExporting: false,
    isOpenDownloadTemplateAndUpload: false,
    PDFView: {
        isLoadingHtmlOffer: false,
        isOpenViewDialog: false,
        ofertaHtml: '',
    },
    isLoadingDownloadPDF: false,
    paths: {
        writeXLSX: '/api/utils/write-xlsx',
        taskIdPath: '/api/utils/task-status/',
        FilesPath: '/api/utils/get-xlsx-files/',
        opcionesUtilsPath: '/api/utils/opciones/',
        utilsPath: '/api/utils/model-query/',
        tipoObjetivoPath: '/api/servicios/tipoobjetivo/',
        getHtmlOfertaPath: '/api/utils/generate-oferta-html/',
        generarPdfPath: '/api/utils/generate-oferta-pdf/',
        tenantInfoPath: '/api/distribuidores/get-distribuidor-info/',
        userDetailPath: '/api/cuentas/detalle/',
        maintenanceStatusPath: '/api/distribuidores/get-maintenance-status/'
    }
})

function readError(error) {

    try {
        let response = JSON.parse(error.request.response)

        function traverseAndFlatten(currentNode, target, flattenedKey) {
            for (var key in currentNode) {
                if (currentNode.hasOwnProperty(key)) {
                    var newKey;
                    if (flattenedKey === undefined) {
                        newKey = key;
                    } else {
                        newKey = flattenedKey + '.' + key;
                    }

                    var value = currentNode[key];
                    if (typeof value === "object") {
                        traverseAndFlatten(value, target, newKey);
                    } else {
                        target[newKey] = value;
                    }
                }
            }
        }

        function flatten(obj) {
            var flattenedObject = {};
            traverseAndFlatten(obj, flattenedObject);
            return flattenedObject;
        }

        return flatten(response)
    }
    catch (error) {
        return "Algo fue mal"
    }
}

// Acciones
const actions = {
    async printThis({ }, { elementId, downloadName, scale=2 }) {
        // var vp = document.getElementById("viewportMeta").getAttribute("content");
        // document.getElementById("viewportMeta").setAttribute("content", "width=1920, height=1080");

        const el = document.getElementById(elementId)

        const options = {
            type: "dataURL",
            scale: scale,
            // width: 1920,
            // height: 1080,
            // windowWidth: 1920,
            // windowHeight: 1080,
        };
        const printCanvas = await html2canvas(el, options);
        // document.getElementById("viewportMeta").setAttribute("content", vp);

        const link = document.createElement("a");
        link.setAttribute("download", `${downloadName}.png`);
        link.setAttribute(
            "href",
            printCanvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream")
        );
        link.click();
    },
    // Este método se utilizará para inicializar el almacenamiento local con las peticiones más comunes en la aplicación
    // aliviando así el tráfico en la API y haciendo la experiencia más fluida
    initialiseLocalStorage({ dispatch }) {
        let initMutationPaths = ['util/fetchOrigenesBBDD', 'login/getUserDetails', 'util/fetchOpciones', 'util/fetchTenantInfo']

        initMutationPaths.forEach((path) => {
            dispatch(path, null, { root: true })
        })
    },
    download_XLSX_from_JSON({ state, dispatch }, { jsonFile, jsonName }) {
        let template = clone(jsonFile)
        const json = JSON.stringify(template);
        const blob = new Blob([json], {
            type: 'application/json'
        });

        dispatch('util/exportDB', {
            params: '',
            files: [blob],
            path: state.paths.writeXLSX,
            title: jsonName,
        }, { root: true })
    },
    async exportDB({ getters, state, dispatch, rootState }, { path, params, title, files }) {
        var ntries = 0        // try {
        let response
        if (files && files.length > 0) {
            let formData = new FormData()

            files.forEach((file, index) => {
                formData.append('file' + index, file)
            });
            let serialized = qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true })
            if (serialized) {
                response = await axios.post(getters.getEndpointFromPath(path) + '?' + serialized,// + '/', 
                    formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            }
            else {
                response = await axios.post(getters.getEndpointFromPath(path) + '/',
                    formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            }

        }
        else {
            response = await axios.get(getters.getEndpointFromPath(path), {
                params: params
            })
        }


        state.exportingProgress = 0
        state.isExporting = true
        let task_id = response.data.task_id

        let export_status = async () => {
            try {
                let response = await axios.get(getters.getEndpointFromPath(state.paths.taskIdPath) + task_id + '/')

                if (response.data.state == 'SUCCESS') {
                    try {
                        if (response.data.result.filename) {
                            let filename = response.data.result.filename
                            response = await axios.get(getters.getEndpointFromPath(state.paths.FilesPath), {
                                params: {
                                    filename: response.data.result.filename,
                                },
                                responseType: 'blob'
                            })

                            let extension = filename.split('.')[1]
                            let typeBlob = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            if (extension == 'json') {
                                typeBlob = 'application/json'
                            }

                            const blob = new Blob([response.data],
                                { type: typeBlob })
                            var fileURL = window.URL.createObjectURL(blob)
                            var fileLink = document.createElement('a')

                            fileLink.href = fileURL
                            fileLink.setAttribute('download', title + '.' + extension)
                            document.body.appendChild(fileLink)

                            fileLink.click();
                            document.body.removeChild(fileLink); // Download complete remove element
                            window.URL.revokeObjectURL(fileURL) // Release blob object
                        }

                        rootState.gerencia.files = []
                        state.exportingProgress = 0
                        state.isExporting = false
                    } catch (error) {
                        dispatch('util/showStatusSnackBar', {
                            error: error,
                            timeout: 4000,
                            statusType: 'error',
                            message: 'Error en la exportación'
                        }, { root: true })
                    }
                } else if (response.data.state == 'FAILURE') {
                    console.log(response.data.result)
                    state.isExporting = false
                    dispatch('util/showStatusSnackBar', {
                        statusType: 'error',
                        message: response.data.result ? response.data.result : 'Ha habido un problema al exportar'
                    }, { root: true })
                } else {
                    if (response.data.result) {
                        let progress = 100 * response.data.result.done / response.data.result.total
                        state.exportingProgress = progress
                    }
                    setTimeout(export_status, 300)
                } 
                // else {
                //     state.isExporting = false
                //     dispatch('util/showStatusSnackBar', {
                //         statusType: 'error',
                //         message: 'Ha habido un problema al exportar'
                //     }, { root: true })
                // }
            }
            catch (error) {
                ntries++
                if (ntries < 30)
                    setTimeout(export_status, 500)
                else {
                    dispatch('util/showStatusSnackBar', {
                        error: error,
                        timeout: 4000,
                        statusType: 'error',
                        message: 'Error en la exportación'
                    }, { root: true })
                }
            }
        }
        export_status()
        // } catch (error) {
        //     dispatch('util/showStatusSnackBar', {
        //         error: error,
        //         timeout: 4000,
        //         statusType: 'error',
        //         message: 'Error en la exportación'
        //     }, { root: true })
        // }
    },
    showStatusSnackBar({ commit }, { statusType, message, error, timeout }) {
        let newStatusSnackBar = {
            statusType: statusType,
            message: message,
            isVisible: true
        }

        if (!timeout)
            timeout = 4000

        if (error) {
            let flattened = readError(error)

            if (typeof (flattened) != 'string') {
                for (let key in flattened) {
                    let clave = key
                    newStatusSnackBar.message = newStatusSnackBar.message + " ## " + clave.replaceAll('.0', '') + " : " + flattened[key] + " ##"
                }
            }
            else {
                newStatusSnackBar.message = newStatusSnackBar.message + " ## " + flattened + " ##"
            }
        }


        if (newStatusSnackBar.statusType == 'success')
            newStatusSnackBar.message = newStatusSnackBar.message + ' ' + '🥳'
        else if (newStatusSnackBar.statusType == 'error')
            newStatusSnackBar.message = newStatusSnackBar.message + ' ' + '😔'
        else
            newStatusSnackBar.message = newStatusSnackBar.message

        commit("StatusSnackBar", newStatusSnackBar)
        setTimeout(() => {
            newStatusSnackBar.isVisible = false
            commit("StatusSnackBar", newStatusSnackBar)
        }, timeout)
    },
    async fetchOrigenesBBDD({ getters, state, commit }) {
        let response = await axios.get(getters.getEndpointFromPath(state.paths.utilsPath), {
            params: {
                model: 'origenBBDD'
            }
        })
        localStorage.setItem('origenesBbdd', JSON.stringify(objectSnakeToCamelCase(response.data)))
    },
    async fetchOpciones({ state, getters, commit }) {
        let response = await axios.get(getters.getEndpointFromPath(state.paths.opcionesUtilsPath))
        localStorage.setItem('opciones', JSON.stringify(objectSnakeToCamelCase(response.data)))
    },
    async getMaintenanceStatus({ state, getters, commit }) {
        let response = await axios.get(getters.getEndpointFromPath(state.paths.maintenanceStatusPath))
        if (response?.data)
            router.push({ name: 'maintenance' })

        localStorage.setItem('maintenanceModeStatus', JSON.stringify(response?.data))

        return response
    },
    async fetchTenantInfo({ state, getters, commit }) {
        let response = await axios.get(getters.getEndpointFromPath(state.paths.tenantInfoPath))
        // commit("tenantInfo", response.data)
        localStorage.setItem('tenantInfo', JSON.stringify(response?.data))
        return response
    },
    async fetchTipoObjetivo({ getters, state, commit }) {
        let response = await axios.get(getters.getEndpointFromPath(state.paths.tipoObjetivoPath))
        commit("tipoObjetivo", response.data)
    },
    async fetchHtmlOffer({ state, getters, dispatch, commit }, offerId) {
        try {
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.getHtmlOfertaPath) + offerId)
            commit('ofertaHtml', resp.data)
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al visualizar la oferta'
            }, { root: true })
        }
    },
    async fetchPDFOffer({ state, getters, dispatch, commit }, offerId) {
        try {
            let resp = await axios.get(
                getters.getEndpointFromPath(state.paths.generarPdfPath) + offerId,
                {
                    responseType: "blob"
                }
            )

            blobPDF(resp, 'Oferta')
        } catch (error) {
            commit('isLoadingDownloadPDF', false)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al descargar el PDF'
            }, { root: true })
            throw error
        }
    }
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
    get_tenant_info: (_state, _unused, rootState) => endpoint => (
        getters.getEndpointFromPath(paths.tenantInfoPath)
    ),
    searchBarEnabled: () => (routeName) => {
        let routesWithSearchBar = [
            '/teletrabajo',
            '/gerencia/comerciales',
            '/gerencia/proyeccion',
            '/gerencia/reporte',
            '/rrhh',
            '/ManagementBase',
            '/devicemanagement',
            '/retailX'
        ]
        // console.log(router.currentRoute)
        return routesWithSearchBar.includes(routeName)
    },
}

// Mutations
const mutations = {
    isOpenLegendDialog: (state, val) => {
        state.isOpenLegendDialog = val
    },
    deleteDialog(state, val) {
        state.deleteDialog = clone(val)
    },
    isOpenDeleteDialog: (state, val) => {
        state.deleteDialog.isOpenDeleteDialog = val
    },
    isMaintaining: (state, val) => {
        state.isMaintaining = val
    },
    tenantInfo: (state, val) => {
        state.tenantInfo = val
    },
    isOpenDownloadTemplateAndUpload(state, val) {
        state.isOpenDownloadTemplateAndUpload = val
    },
    isLoadingDownloadPDF(state, val) {
        state.isLoadingDownloadPDF = val
    },
    StatusSnackBar(state, val) {
        state.StatusSnackBar = val
    },
    navBarSearchField(state, val) {
        state.navBarSearchField = val
    },
    origenesBbdd(state, val) {
        state.origenesBbdd = clone(val)
    },
    opciones(state, val) {
        state.opciones = objectSnakeToCamelCase(val)
    },
    tipoObjetivo(state, val) {
        state.tipoObjetivo = clone(val)
    },
    PDFView(state, val) {
        state.PDFView = val
    },
    isLoadingPDFView(state, val) {
        state.PDFView.isLoadingHtmlOffer = val
    },
    ofertaHtml(state, val) {
        state.PDFView.ofertaHtml = val
    },
    isOpenViewDialog(state, val) {
        state.PDFView.isOpenViewDialog = val
    },
    exportingProgress(state, val) {
        state.PDFView.exportingProgress = val
    },
    isExporting(state, val) {
        state.PDFView.isExporting = val
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    readError,
    mutations
}